import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import CreateEntity from 'components/crud/CreateEntity';
import FieldForm from './FieldForm';
import { IDropdowns, IInputs } from '../types';

interface IProps {
  fieldsEntityName: string;
  fieldDataOptions: IDropdowns;
}

const CreateForm: FC<IProps> = ({ fieldsEntityName, fieldDataOptions }: IProps) => {
  const { client } = useActiveClientContext();
  const { showModal } = useModal();
  const methods = useForm<IInputs>({
    defaultValues: {
      is_active: true,
    },
  });

  const isMultilingual = client?.is_multilingual;

  return (
    <CreateEntity
      entity={fieldsEntityName}
      methods={methods}
      onSuccess={(res: any) => {
        const { name } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              Създадохте поле&nbsp;
              <span className="font-weight-bold">{name}</span>.
            </>
          ),
        });
      }}
      queryKey={buildClientEntity(fieldsEntityName, client)}
      onSuccessPushToLink={buildClientUrl('/fields', client)}
    >
      {(create: any) => (
        <FieldForm
          methods={methods}
          handleSubmit={data => {
            const formatData = {
              ...data,
              type: data.type.value,
              default_value: data.default_value?.value,
              identifier: data.identifier?.value,
              hidden_identifier: data.hidden_identifier?.value || null,
              mass_doc_behavior: data.mass_doc_behavior?.value,
              options: data.options?.map((opt: any) => opt.value.toString()),
              ...(isMultilingual && {
                options_en: data.options_en?.map((opt: any) => opt.value.toString()),
              }),
              ...(data.type.value === 'numeric-integer' && {
                min_length: data.min_length || 0,
              }),
            };
            return create(formatData);
          }}
          btnLabel="Запази"
          fieldDataOptions={fieldDataOptions}
          canEdit
          isMultilingual={isMultilingual}
        />
      )}
    </CreateEntity>
  );
};

export default CreateForm;
